import React from "react";
import { columns } from "./Columns";
import BaseTable from "./BaseTable";
import { settingsApi } from "@/apis/apis";
import SettingManagementModal from "@/Modals/SettingManagementModal/Modal";

export default function SettingManagementPage() {
  return (
    <BaseTable
      label="Setting Management"
      apiURL={settingsApi}
      columns={columns()}
      ModalComponent={SettingManagementModal}
      enableSortData={false}
      enableStatus={false}
      enableExport={false}
      enableAdd={false}
    />
  );
}
